import moment from "moment/moment";
import { useMessageSource } from "react-message-source";
import * as Yup from "yup";
import { useDateValidator } from "../validator";

export default function useBirthDateValidator(): Yup.StringSchema {
  const { getMessage } = useMessageSource();

  const birthDateValidator = Yup.string()
    .required(getMessage("Validation.message-required"))
    .test(
      "isOlderThan18",
      getMessage("Validation.message-mustBeMoreThan18YearsOld"),
      (date) => {
        const eighteenYearsAgo = moment().subtract(18, "years");
        const parsedDate = moment(date, "DD.MM.YYYY");
        return parsedDate.isBefore(eighteenYearsAgo);
      },
    );

  return useDateValidator().concat(birthDateValidator);
}
